import type React from "react";
import { CircularSpinner } from "./circular-spinner";

export function PredictionLoadingState({
  children,
}: {
  children: React.ReactNode;
}) {
  return <p className="text-r8-gray-10">{children}</p>;
}
